import React, { type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { logger } from '../utils/logger';
interface Props {
  children: ReactNode;
}

export const OuterErrorBoundary = ({ children }: Props) => {
  return (
    <ErrorBoundary
      fallback={null}
      onError={(error) => {
        logger.error("Caught error in AppWrapper", error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
